import { NgClass, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogModule } from '@angular/material/legacy-dialog';
import { TranslateModule } from '@ngx-translate/core';

export interface MessageBoxData {
  icon: 'done' | 'clear';
  text: string;
}

@Component({
  selector: 'ten-message-box',
  templateUrl: './message-box.component.html',
  styleUrls: ['./message-box.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [MatIconModule, NgIf, NgClass, MatLegacyDialogModule, MatLegacyButtonModule, TranslateModule],
})
export class MessageBoxComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public messageBoxData: MessageBoxData) {}
}
